import React, { Component } from "react";
class RadioInput extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
        }
    }

    componentDidMount()
    {
    }

    componentDidUpdate()
    {
      if (this.props.onChange) this.props.onChange();
    }

    getValue()
    {
        return this.state.value;
    }

    setValue(value)
    {
        this.setState({value:value})
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
        
      };
    
      render() {
        const { value } = this.state;
    
        const containerStyle = {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '10px',
          padding: '2px',
          fontFamily: 'Segoe UI, sans-serif',
        };
    
        const labelStyle = {
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
          cursor: 'pointer'
        };
    
        const radioStyle = {
          accentColor: '#0078D7', // Windows blue
          width: '16px',
          height: '16px'
        };
    
        return (
          <div style={containerStyle}>
            <label style={labelStyle}>
              <input
                type="radio"
                name="option"
                value="0"
                checked={value==="0"}
                onChange={this.handleChange}
                style={radioStyle}
              />
              {this.props.title1}
            </label>
    
            <label style={labelStyle}>
              <input
                type="radio"
                name="option"
                value="1"
                checked={value === "1"}
                onChange={this.handleChange}
                style={radioStyle}
              />
              {this.props.title2}
            </label>
    
          </div>
        );
      }
}
RadioInput.defaultProps = 
{
    autoFocus: false,
    readOnly: false,
    disabled: false,
}

export default RadioInput